export default __webpack_public_path__ + "static/media/kids.1a8dd4b8.mp4";